




























import { defineComponent, ref } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import { $t } from "@/lib/i18nHelpers";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import VaultCategoryList from "../VaultCategoryList";

export default defineComponent({
  name: "VaultMoveConfirm",
  components: { BaseConfirm, VaultCategoryList, BaseButton },
  props: {
    show: { type: Boolean, default: false },
    categoryList: { type: Array as () => VaultCategory[], default: () => [] },
    subTitle: { type: String, default: $t("Select a album to move files") },
    confirmTitle: { type: String, default: $t("Move files") },
    confirmButtonText: { type: String, default: $t("Move") },
    loading: { type: Boolean, default: false },
    scroll: { type: Boolean },
  },
  setup(props, { emit }) {
    const checkedCategoryId = ref<string>("");
    const onClickCategory = (category: VaultCategory): void => {
      checkedCategoryId.value = category.id;
      emit("clickCategory", category);
    };

    return {
      checkedCategoryId,
      onClickCategory,
    };
  },
});
